
import { Card } from "@/components/ui/card";

export function EmptyPrayerRequests() {
  return (
    <Card className="shadow-none border-[#333344] p-4 bg-[#151520]/80 backdrop-blur-sm">
      <p className="text-center text-gray-400">
        No prayer requests yet. Be the first to share one!
      </p>
    </Card>
  );
}
